import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {WidgetValidator} from '@pt/pt-models';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ValidatorGenerator} from '../../utils';

@Component({
  selector: 'pt-input-filtered-select-with-footer-action',
  templateUrl: './input-filtered-select-with-footer-action.component.html',
  styles: [`
    .input-filtered-select-footer {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  `],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputFilteredSelectWithFooterActionComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputFilteredSelectWithFooterActionComponent),
      multi: true
    }
  ]
})
export class InputFilteredSelectWithFooterActionComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() controlName: string;
  @Input() validators: WidgetValidator[];
  @Input() label: string;
  @Input() placeholder: string;
  @Input() notFoundText: string;
  @Input() help: string;
  @Input() error: string;    // Da implementare
  @Input() options: InputFilteredSelectWitFooterActionData<any>;
  @Input() disabled: boolean;

  @Output() actionClick = new EventEmitter();

  public formGroup: FormGroup;
  isRequired: boolean;
  inputId: string;
  isChanged = false;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.inputId = 'ptWFilteredSelect_' + this.controlName;

    this.isRequired = ValidatorGenerator.validatorsContainsRequired(this.validators);

    this.setFormGroup();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChanged = t.value !== null;
      if (this.onChanged) {
        this.onChanged(t.value);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

  writeValue(obj: any): void {
    this.formGroup.controls.value.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.controls.value.disable();
    } else {
      this.formGroup.controls.value.enable();
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    const validator = ValidatorGenerator.generateValidator(this.validators);
    this.formGroup = new FormGroup({
      value: new FormControl(null, validator)
    });
  }
}

export interface InputFilteredSelectWitFooterActionData<E> {
  bindLabel: string;
  bindValue: string;
  items: E[];
  footerAction: {
    label: Observable<string>
  }
}
